import smartSearchReducer from './smartSearchReducer';

export * from './smartSearchActions';
export default smartSearchReducer;
